import Vue from 'vue'
import { Row,Col,Button,Menu,MenuItem,Icon,MenuGroup,Input,InputNumber,Steps,Step,Modal,Cascader,Dropdown,DropdownMenu,DropdownItem,Switch } from 'iview'

Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Button', Button);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Icon', Icon);
Vue.component('MenuGroup', MenuGroup);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Steps', Steps);
Vue.component('Step', Step);
Vue.component('Modal', Modal);
Vue.component('Cascader', Cascader);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('i-Switch', Switch);

import 'iview/dist/styles/iview.css'
